<template>
  <a-switch
    v-model:checked="innerValue"
    :disabled="disabled"
    :size="size === 'small' ? 'small' : 'default'"
    :loading="loading"
    :checked-children="checkedChildren"
    :un-checked-children="unCheckedChildren"
    @change="onChange"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
  modelValue?: boolean;
  disabled?: boolean;
  loading?: boolean;
  size?: "default" | "small" | "middle" | "large";
  checkedChildren?: string;
  unCheckedChildren?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
  loading: false,
  size: "default",
  checkedChildren: "",
  unCheckedChildren: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "change", value: boolean): void;
}>();

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (checked: boolean) => {
  emit("update:modelValue", checked);
  emit("change", checked);
};
</script>

<!--
  Hướng dẫn sử dụng — Switch
  Global: <h-switch v-model="enabled" checked-children="Bật" un-checked-children="Tắt" />
  Import: import { Switch } from '@/components/ant/select'

  Props: modelValue (boolean), disabled, loading, size, checkedChildren, unCheckedChildren
  Events: update:modelValue, change
  Docs: src/components/ant/select/README.md
-->
